module.exports = "/images/thumbnails-icon-dark.svg?0e30dfac20c317599bce9476d7e01dd5";